import { render } from "./slide3.vue?vue&type=template&id=1c3f5f43&scoped=true"
import script from "./slide3.vue?vue&type=script&lang=js"
export * from "./slide3.vue?vue&type=script&lang=js"

import "./slide3.vue?vue&type=style&index=0&id=1c3f5f43&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3f5f43"]])

export default __exports__